import React from 'react';
import { motion } from 'framer-motion';
import { Clock } from 'lucide-react';
export function UrgencySection() {
  return <section id="urgency" className="py-16 md:py-24 bg-white" data-id="element-329">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-330">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-10" data-id="element-331">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-orange-100 text-orange-600 mb-6" data-id="element-332">
            <Clock className="w-8 h-8" data-id="element-333" />
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-[#1B2E1B] mb-6" data-id="element-334">
            ACT TODAY — NOT TOMORROW
          </h2>
          <div className="w-24 h-1 bg-orange-500 mx-auto rounded-full" data-id="element-335"></div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="space-y-6 text-lg text-gray-700 text-center" data-id="element-336">
          <p className="font-semibold text-xl text-red-600" data-id="element-337">
            Houston summers are brutal on your lawn.
          </p>

          <p data-id="element-338">
            Every week you wait is another week of uncontrolled growth, weeds,
            and dry soil that's harder and more expensive to recover.
          </p>

          <div className="bg-[#f9f7f2] p-6 rounded-xl border border-gray-200 my-8" data-id="element-339">
            <p className="font-bold text-[#1B2E1B] text-xl mb-2" data-id="element-340">
              Customers who call today get priority on our schedule.
            </p>
            <p className="text-gray-600 italic" data-id="element-341">
              Those who wait... wait longer.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}